var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('td',_vm._b({staticClass:"analysisTableCell",style:(_vm.style),on:{"mouseenter":_vm.onMouseEnter,"mouseleave":_vm.onMouseLeave,"click":_vm.onClick}},'td',_vm.colspanRowspan,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }